import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { loginAPI,forgotPasswordAPI,fetchDropdownDataAPI } from '../services/userApi'; // ตรวจสอบให้แน่ใจว่าเส้นทางนี้ถูกต้อง
import backgroundImage from '../assets/Bg.jpg';
import backgroundImage2 from '../assets/contentbg.jpg';
import closeBTN from '../assets/close.png';
import logostarcastnews from '../assets/logoMXR.png';
import passwordicon from '../assets/icon_Rock.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-regular-svg-icons';
import Modal from 'react-modal';


const LoginPage = () => {
    const MySwal = withReactContent(Swal);
    const [isModalOpen, setModalOpen] = useState(false);
    const [isForgotPasswordOpen, setForgotPasswordOpen] = useState(false);

    const navigate = useNavigate();
    
    const onError = (title,response) => {
        MySwal.fire({
            title: title,
            html: response?.data?.error?.message,
            icon: "error",
            confirmButtonText: "Close",
            allowOutsideClick: false,
        }).then(async (result) => {
          if (result.isConfirmed) {
              if(response?.status===401) {
                  sessionStorage.removeItem('hasVisited');
                  sessionStorage.removeItem('lastPath');        
                  localStorage.removeItem('account');                  
                  navigate('/');
              };
          }
        });
    };

    const onSuccess = (title, message) => {
        MySwal.fire({
            icon: 'success',
            title: title,
            text: message,
            confirmButtonText: 'OK',
            allowOutsideClick: false,
        });
    };
    

    const toggleLoginPopup = () => {
        if (!isForgotPasswordOpen) {
            setModalOpen(!isModalOpen);
        }
    };
    
    const toggleForgotPasswordPopup = () => {
        setForgotPasswordOpen(!isForgotPasswordOpen);
        setModalOpen(false);
    };
    
    
    const onSubmit = async (e) => {
        e.preventDefault();
        const form = e.target;
        const email = form.email.value.trim();
        const password = form.password.value.trim();
      
      
      
        try {
          const result = await loginAPI(email, password);
      
          // ตรวจสอบกรณี password เป็น null
          if (result?.data?.account?.password === null) {
            toggleForgotPasswordPopup(); // เรียก popup
            return;
          }
      
          if (result?.status === true) {
            localStorage.setItem("account", JSON.stringify(result.data.account));
      
            // เรียก fetchDropdownDataAPI
            try {
              const courseDataResult = await fetchDropdownDataAPI();
              localStorage.setItem("courseData", JSON.stringify(courseDataResult));
            } catch (fetchError) {
              console.error('Error fetching dropdown data:', fetchError.message);
              onError("Error fetching dropdown data", { data: { error: { message: fetchError.message } } });
              return;
            }
      
            navigate('/main');
          } else {
            const errorMessage = result?.error?.message || 'Login failed';
            onError('Login Failed', { data: { error: { message: errorMessage } } });
          }
        } catch (error) {
          console.error('Login error:', error);
          onError("Login error", { data: { error: { message: error.message || 'An unexpected error occurred during login' } } });
        }
      };
      
                      
    const handleForgotPasswordSubmit = async (e) => {
        e.preventDefault();
        const email = e.target.email.value.trim();
    
        if (!email) {
            onError('Input Error', { data: { error: { message: 'Please enter your email' } } });
            return;
        }
    
        try {
            const result = await forgotPasswordAPI(email);
    
            if (result?.status === true) {
                onSuccess('Success', 'เราได้ส่งอีเมลสำหรับรีเซ็ตรหัสผ่านให้คุณแล้ว กรุณาคลิกลิงก์ในอีเมลเพื่อยืนยันและตั้งรหัสผ่านของคุณใหม่');
                setForgotPasswordOpen(false);
    
                navigate('/');
            } else {
                const errorMessage = result?.error?.message || 'Reset password failed';
                onError('Reset Failed', { data: { error: { message: errorMessage } } });
            }
        } catch (error) {
            onError('Error', error?.response || { data: { error: { message: 'An unexpected error occurred' } } });
        }
    };
        
    const styles = {
        container: {
            width: '100%',
            height: '100vh', // ความสูงเต็มของ outerContainer
            display: 'flex',
            alignItems: 'center',
            overflowY: 'auto', // สามารถเลื่อนในแนว Y
            overflowX:'hidden'
 
        },
        popup: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',

            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
        },
        popupContent: {
            backgroundImage: `linear-gradient(to bottom, rgba(199, 199, 199, 1), rgba(199, 199, 199, 0.5)), url(${backgroundImage})`,
            padding: '40px',
            borderRadius: '36px',
            width: '100%',
            height:'100%',
            maxHeight: '500px',
            maxWidth: '764px',
            position: 'relative',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            
        },
        popupContent2: {
            background: '#374151',
            padding: '40px',
            borderRadius: '36px',
            width: '100%',
            height:'80%',
            maxHeight: '1613px',
            maxWidth: '764px',
            position: 'relative',
            overflowY:'auto',
            scrollbarWidth: 'none', /* สำหรับ Firefox */
            msOverflowStyle: 'none'  /* สำหรับ Internet Explorer และ Edge */
        },
        closeButton: {
            position: 'absolute',
            top: '10px',
            right: '10px',
            cursor: 'pointer',
        },
        inputContainer: {
            marginBottom: '15px',
            display: 'flex',
            alignItems: 'center',
        },
        input: {
            flex: 1,
            padding: '10px 70px 10px 70px',
            border: 'none',
            borderRadius: '36px',
            width: '100%',
            height: '45px',
            maxWidth:'670.78px',
            fontSize:'24px',
        },
        dropdownContainer: {
            marginBottom: '15px',
        },
        dropdown: {
            position: 'relative',
            cursor: 'pointer',
        },
        dropdownContent: {
            position: 'absolute',
            backgroundColor: '#fff',
            border: '1px solid #ddd',
            borderRadius: '4px',
            zIndex: 1,
            width: '100%',
            display: 'block',
        },
        dropdownItem: {
            padding: '10px',
            cursor: 'pointer',
        },
        button: {
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '0',
        },
        closeandlogin:{
            display: 'flex',
        },
        background: {
            position: 'fixed',
            width: '100%',
            height: '100%',
            top: '0',
            left: '0',
            backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.25)), url(${backgroundImage})`,
            boxShadow: '0px 4px 4px 0px rgba(255, 255, 255, 0.5)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            zIndex: '-1',
        },
        watermarkStyle:{
            position: 'absolute',
            top: '95%',
            left: '80%',
            transform: 'translate(-50%, -50%)',
            fontSize: '20px',
            color: 'rgba(0, 0, 0, 0.1)', // สีจาง
            pointerEvents: 'none', // ไม่ให้คลิกได้
            zIndex: 9999, // ให้อยู่ด้านบนสุด
            whiteSpace:'nowrap'
        },
        iframeContainerStyle: {
            width: '100%',
            height: '100%',
            overflow: 'hidden', // ซ่อน scrollbar ของ container
            position: 'relative',
        },
        iframeStyle: {
            position: 'absolute',
            top: '25px', // เลื่อน iframe ลงมาให้แสดงเฉพาะส่วนที่ต้องการ
            left: '50%', // ตั้งให้จุดอ้างอิงของ iframe อยู่ตรงกลาง container
            transform: 'translateX(-50%)', // เลื่อน iframe กลับไปครึ่งหนึ่งของความกว้าง เพื่อให้อยู่กึ่งกลาง
            width: '110%', // ขนาด iframe ที่เกิน container
            height: '100%',
            border: 'none',
            overflow: 'scroll', // ยังคงเลื่อนได้ภายใน iframe
        },
        
    };

    return (
        <div style={styles.outerContainer}>
            <div style={styles.container}>
                <header>
                    <nav
                        style={{
                            position: 'fixed',
                            top: 0,
                            width: '100%',
                            height: '90px',
                            background: 'linear-gradient(90deg, #7C93B7 0%, #374151 100%)',
                            boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.5)',
                            zIndex: 1,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '4px 140px',
                            boxSizing: 'border-box',
                            overflow: 'hidden',
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <img
                                src={logostarcastnews}
                                alt="logostartcast"
                                style={{
                                    height: '100%',
                                    marginRight: '15px',
                                }}
                            />
                            {/* <a href="/news" style={{
                                    color: '#F9FAFB',
                                    fontSize: '24px',
                                    textDecoration: 'none',
                                    padding: '91px',
                                }}
                            >
                                หน้าหลัก
                            </a> */}
                        </div>
                        <a
                            style={{
                                color: '#ffffff',
                                fontSize: '24px',
                                textDecoration: 'none',
                                cursor:'pointer'
                            }}
                            onClick={toggleLoginPopup}
                        >
                            เข้าสู่ระบบ
                        </a>
                    </nav>
                </header>
                    <div style={styles.iframeContainerStyle}>
                        <iframe
                            title="myIframe"
                            src="https://metaversexr.tech/" /*https://intell.rtaf.mi.th/homepage*/
                            style={styles.iframeStyle}
                        ></iframe>
                    </div>
            </div>
                
            <Modal
                isOpen={isModalOpen}
                onRequestClose={toggleLoginPopup}
                style={{
                    overlay: {
                         backgroundColor: 'rgba(0, 0, 0, 0.5)',
                         zIndex: 2,
                    },
                    content: {
                        top: '50%',
                        left: '50%',
                        right: 'auto',
                        bottom: 'auto',
                        marginRight: '-50%',
                        transform: 'translate(-50%, -50%)',
                        width: '100%',
                        maxWidth:'764px',
                        padding: '24px 54px 24px 54px',
                        borderRadius: '36px',
                        boxSizing:'border-box',
                        backgroundColor: 'rgba(200,200,200,1)',
                    }
                }}
                >
                <div style={{display:'flex',justifyContent:'space-between'}}>
                    <h2 style={{fontSize:'64px',marginTop:'0',marginBottom:'42px'}}>เข้าสู่ระบบ</h2>
                    <button onClick={toggleLoginPopup} 
                            style={{ 
                                marginTop: '20px',
                                background:'none',
                                border:'none', 
                                width:'100%',
                                maxWidth:'96px',
                                cursor:'pointer'
                                    
                            }}>
                        <img src={closeBTN} alt="closeBTN" style={{ maxWidth:'96px',}}/>
                    </button>
                    </div>
                    <form onSubmit={onSubmit}>
                        <div style={{ position: 'relative', marginBottom: '20px',alignItems:'center',boxSizing:'border-box', }}>
                            <input
                                type="text"
                                name="email"
                                required
                                placeholder="Email"
                                style={{ 
                                    padding: '2px 42px  2px 90px',
                                    borderRadius:'64px',
                                    border:'none',
                                    alignItems:'center',
                                    width:'100%',
                                    boxSizing:'border-box',
                                    height:'77.12px',
                                    fontSize:'24px',
                                    color: 'black'
                                }} 
                            />
                            <FontAwesomeIcon icon={faUser} style={{ position: 'absolute', left: '42px', top: '50%', transform: 'translateY(-50%)', color: '#9CA3AF',fontSize:'32px' }} />
                    </div>
                        <div style={{ position: 'relative', marginBottom: '20px' }}>
                            <input
                                type="password"
                                name="password"
                                
                                placeholder="รหัสผ่าน"
                                style={{
                                    padding: '2px 42px  2px 90px',
                                    borderRadius:'64px',
                                    border:'none',
                                    alignItems:'center',
                                    width:'100%',
                                    boxSizing:'border-box',
                                    height:'77.12px',
                                    fontSize:'24px',
                                    color: 'black'
                                 }} // เพิ่มพื้นที่ให้ไอคอน
                            />
                            <img src={passwordicon} alt="Password Icon" style={{ position: 'absolute', left: '30px', top: '50%', transform: 'translateY(-50%)', width: '100%', maxWidth:'50px'}} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end',  }}>
                        <span
                            onClick={toggleForgotPasswordPopup}
                            style={{ 
                                color: '#44526E', 
                                textDecoration: 'underline', 
                                cursor: 'pointer',
                                fontSize:'24px'
                            }}
                        >
                            ลืมรหัสผ่าน?
                        </span>
                    </div>
                    <button type="submit" 
                            style={{
                                width:'100%',
                                boxSizing:'border-box',
                                borderRadius:'64px',
                                height:'64px',
                                background:'#44526E',
                                color:'#F9FAFB',
                                border:'none',
                                marginTop:'42px',
                                fontSize:'24px',
                                cursor:'pointer'
                            }}
                        >
                        เข้าสู่ระบบ
                    </button>
                </form>
            </Modal>
            <Modal
                isOpen={isForgotPasswordOpen} // ใช้ isForgotPasswordOpen แทน isModalOpen
                onRequestClose={() => setForgotPasswordOpen(false)} // ปิด modal ของการรีเซ็ตรหัสผ่าน
                style={{
                    overlay: {
                         backgroundColor: 'rgba(0, 0, 0, 0.5)',
                         zIndex: 2,
                    },
                    content: {
                        top: '50%',
                        left: '50%',
                        right: 'auto',
                        bottom: 'auto',
                        marginRight: '-50%',
                        transform: 'translate(-50%, -50%)',
                        width: '100%',
                        maxWidth:'764px',
                        padding: '24px 54px 24px 54px',
                        borderRadius: '36px',
                        boxSizing:'border-box',
                        backgroundImage: `
                            linear-gradient(
                                rgba(199, 199, 199, 0.25),
                                rgba(199, 199, 199, 0.25)
                            ),
                            url(${backgroundImage2})
                            `,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    }
                }}
            >
               <div style={{ padding: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '64px' }}>
                    <h2 style={{ fontSize: '64px', margin: '0', lineHeight: '64px' }}>รหัสผ่าน</h2>
                    <button 
                        onClick={() => setForgotPasswordOpen(false)} 
                        style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer'
                        }}
                    >
                        <img src={closeBTN} alt="closeBTN" style={{ maxWidth: '96px' }}/>
                    </button>
                </div>
                <p style={{fontSize:'24px',marginTop:'10px'}}>กรุณาใส่อีเมลของคุณ เราจะทำการส่งลิ้งค์เพื่อตั้งรหัสผ่านใหม่ไปยังอีเมลของคุณ</p>
                <form onSubmit={handleForgotPasswordSubmit}>
                    <div style={{ position: 'relative',alignItems:'center',boxSizing:'border-box', }}>
                            <input
                                type="email"
                                name="email"
                                required
                                placeholder="กรุณากรอกอีเมล"
                                style={{ 
                                    padding: '42px',
                                    borderRadius:'64px',
                                    border:'none',
                                    alignItems:'center',
                                    width:'100%',
                                    boxSizing:'border-box',
                                    height:'77.12px',
                                    fontSize:'24px',
                                    color: 'black'
                                }} 
                            />
                    </div>
                    <button type="submit" 
                            style={{
                                width:'100%',
                                boxSizing:'border-box',
                                borderRadius:'64px',
                                height:'64px',
                                background:'#44526E',
                                color:'#F9FAFB',
                                border:'none',
                                marginTop:'24px',
                                fontSize:'24px',
                                cursor:'pointer'
                            }}
                        >
                        ยืนยัน
                    </button>
                </form>
            </Modal>
            

            {/* <div style={styles.watermarkStyle}>
               
            </div> */}
        </div>
    );
    
};

export default LoginPage;
